const DEFAULT_PAGE = 1;

export const parsePageNumber = (value) => {
    const page = Number.parseInt(value, 10);
    if (!Number.isFinite(page) || page < DEFAULT_PAGE) {
        return DEFAULT_PAGE;
    }
    return page;
};

export const getOffsetForPage = (page = DEFAULT_PAGE, pageSize = 1) => {
    const safePage = parsePageNumber(page);
    const safePageSize = Math.max(Number.parseInt(pageSize, 10) || 1, 1);
    return (safePage - 1) * safePageSize;
};

export const normalizeRoutePath = (value = '/') => {
    const rawValue = `${value || '/'}`.trim() || '/';
    const [, rawPathname = '/', suffix = ''] = rawValue.match(/^([^?#]*)([?#].*)?$/) || [];
    const withoutTrailingSlash = rawPathname.replace(/\/+$/, '');
    const normalizedPathname = withoutTrailingSlash.replace(/^\/+/, '');

    if (!normalizedPathname) {
        return `/${suffix}`;
    }

    return `/${normalizedPathname}/${suffix}`;
};

export const buildPaginatedPath = (basePath = '/', page = DEFAULT_PAGE, currentQuery = {}) => {
    const safePage = parsePageNumber(page);
    const normalizedBasePath = normalizeRoutePath(basePath);
    const nextQuery = { ...(currentQuery || {}) };

    if (safePage <= DEFAULT_PAGE) {
        delete nextQuery.page;
    } else {
        nextQuery.page = `${safePage}`;
    }

    const searchParams = new URLSearchParams();
    Object.entries(nextQuery).forEach(([key, value]) => {
        if (value === null || typeof value === 'undefined' || value === '') {
            return;
        }
        searchParams.set(key, `${value}`);
    });

    const queryString = searchParams.toString();
    return queryString ? `${normalizedBasePath}?${queryString}` : normalizedBasePath;
};

export const normalizePaginatedFullPath = (basePath = '/', page = DEFAULT_PAGE, currentQuery = {}, hash = '') => {
    const normalizedPath = buildPaginatedPath(basePath, page, currentQuery);
    return hash ? `${normalizedPath}${hash}` : normalizedPath;
};

export const replaceBrowserUrl = (targetPath = '/') => {
    if (typeof window === 'undefined' || typeof window.history?.replaceState !== 'function') {
        return;
    }

    const currentBrowserPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (currentBrowserPath === targetPath) {
        return;
    }

    window.history.replaceState(window.history.state, '', targetPath);
};
